import { useMutation } from '@tanstack/react-query'
import type { MutateFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import { GenericError } from '../../utils'

export function useAuthMutation<TData = unknown, TVariables = unknown, TContext = unknown>(
  mutationFn: MutateFunction<TData, GenericError, TVariables, TContext>,
  mutationOptions?: Omit<
    UseMutationOptions<TData, GenericError, TVariables, TContext>,
    'mutationFn'
  >,
): UseMutationResult<TData, GenericError, TVariables, TContext> {
  const useMutationResponse = useMutation({
    mutationFn,
    ...mutationOptions,
  })

  return useMutationResponse
}
